import * as Yup from 'yup';

export const validationSchema = ({ t }) =>
  Yup.object().shape({
    name: Yup.string('')
      .required(t('Name is required'))
      .nullable(),
    description: Yup.string().nullable()
  });

export default validationSchema;
